import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShortenFileNamePipe } from '../../../pipes/framework/shorten-file-name.pipe';
import { UploadDropDirective } from '../../../directives/upload-drop.directive';
import { ManagedFile, FileEvent, UploadableContent } from '@app/framework/interfaces/file.type';

/**
 * Default upload component mainly used for input file upload with default UI
 * It's role is simply to display the files and handle events to emit open file input window, remove file and file dropped
 */
@Component({
  selector: 'app-default-upload-ui',
  templateUrl: './default-upload-ui.component.html',
  styles: ['animate-shake { border: none !important; }'],
  imports: [CommonModule, ShortenFileNamePipe, UploadDropDirective],
})
export class DefaultUploadUiComponent {
  @Input() disableUpload = false;
  @Input() hideRemoveFileIcon = false;
  @Input() files: ManagedFile[] = [];
  @Input() placeholder = 'Click to upload files';
  @Input() label = '';

  @Output() fileDropped = new EventEmitter<File[]>();
  @Output() openWindow = new EventEmitter<void>();
  @Output() removeFile = new EventEmitter<FileEvent>();

  onFileDropped($event: UploadableContent[]) {
    this.fileDropped.emit($event as File[]);
  }

  onOpenWindow() {
    this.openWindow.emit();
  }

  onRemoveFile(file: ManagedFile, index: number) {
    this.removeFile.emit({ file, index });
  }
}
